// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { BuildRequest, BuildRequestT } from "./build-request";
import { CheckRequest, CheckRequestT } from "./check-request";
import { EventsCheckRequest, EventsCheckRequestT } from "./events-check-request";
import { IdlResult, IdlResultT } from "./idl-result";
import { InflateRequest, InflateRequestT } from "./inflate-request";
import { ValidateRequest, ValidateRequestT } from "./validate-request";

export enum IdlBody {
  NONE = 0,
  ValidateRequest = 1,
  BuildRequest = 2,
  CheckRequest = 3,
  InflateRequest = 4,
  IdlResult = 5,
  EventsCheckRequest = 6,
}

export function unionToIdlBody(
  type: IdlBody,
  accessor: (
    obj:
      | BuildRequest
      | CheckRequest
      | EventsCheckRequest
      | IdlResult
      | InflateRequest
      | ValidateRequest,
  ) =>
    | BuildRequest
    | CheckRequest
    | EventsCheckRequest
    | IdlResult
    | InflateRequest
    | ValidateRequest
    | null,
):
  | BuildRequest
  | CheckRequest
  | EventsCheckRequest
  | IdlResult
  | InflateRequest
  | ValidateRequest
  | null {
  switch (IdlBody[type]) {
    case "NONE":
      return null;
    case "ValidateRequest":
      return accessor(new ValidateRequest())! as ValidateRequest;
    case "BuildRequest":
      return accessor(new BuildRequest())! as BuildRequest;
    case "CheckRequest":
      return accessor(new CheckRequest())! as CheckRequest;
    case "InflateRequest":
      return accessor(new InflateRequest())! as InflateRequest;
    case "IdlResult":
      return accessor(new IdlResult())! as IdlResult;
    case "EventsCheckRequest":
      return accessor(new EventsCheckRequest())! as EventsCheckRequest;
    default:
      return null;
  }
}

export function unionListToIdlBody(
  type: IdlBody,
  accessor: (
    index: number,
    obj:
      | BuildRequest
      | CheckRequest
      | EventsCheckRequest
      | IdlResult
      | InflateRequest
      | ValidateRequest,
  ) =>
    | BuildRequest
    | CheckRequest
    | EventsCheckRequest
    | IdlResult
    | InflateRequest
    | ValidateRequest
    | null,
  index: number,
):
  | BuildRequest
  | CheckRequest
  | EventsCheckRequest
  | IdlResult
  | InflateRequest
  | ValidateRequest
  | null {
  switch (IdlBody[type]) {
    case "NONE":
      return null;
    case "ValidateRequest":
      return accessor(index, new ValidateRequest())! as ValidateRequest;
    case "BuildRequest":
      return accessor(index, new BuildRequest())! as BuildRequest;
    case "CheckRequest":
      return accessor(index, new CheckRequest())! as CheckRequest;
    case "InflateRequest":
      return accessor(index, new InflateRequest())! as InflateRequest;
    case "IdlResult":
      return accessor(index, new IdlResult())! as IdlResult;
    case "EventsCheckRequest":
      return accessor(index, new EventsCheckRequest())! as EventsCheckRequest;
    default:
      return null;
  }
}

export type IdlBodyT =
  | { type: "NONE"; value: null }
  | { type: "ValidateRequest"; value: ValidateRequestT }
  | { type: "BuildRequest"; value: BuildRequestT }
  | { type: "CheckRequest"; value: CheckRequestT }
  | { type: "InflateRequest"; value: InflateRequestT }
  | { type: "IdlResult"; value: IdlResultT }
  | { type: "EventsCheckRequest"; value: EventsCheckRequestT };
